import './footer.scss'

export default function Footer() {
  return (
    <footer id="footer">
        &copy; {new Date().getFullYear()} Minnedev, LLC. Design by Julie Cestaro
    </footer>
  )
}